import * as ViewModel from '@/core/presenter/viewModel';
import clsx from 'clsx';

interface IProps {
  sendAsset: string;
  isWritting: boolean;
  curculateKrw: string;
  selectedAsset: ViewModel.IAsset | undefined;
  onChangeSelectedAsset: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onClickResetAmountBtn: () => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SendCheckAmountBox = ({
  sendAsset,
  isWritting,
  selectedAsset,
  curculateKrw,
  onChangeSelectedAsset,
  onClickResetAmountBtn,
}: IProps) => {
  return (
    <div
      className={clsx('send-amount-group send-filled-group', !isWritting && 'hidden')}
      style={{ display: isWritting ? 'flex' : 'none' }}
    >
      <label className="send-amount-label text-base font-medium">보낼 수량:</label>
      <div className="send-amount-display">
        <div className="amount-values">
          <div className="amount-gdf-group">
            <span className="amount-input-wrapper">
              <span className="amount-input-mirror" id="amountMirror">
                {sendAsset || '0'}
              </span>
              <input
                type="text"
                id="send-amount"
                name="send-amount"
                className="send-amount-input text-lg font-normal"
                inputMode="decimal"
                value={sendAsset}
                onChange={onChangeSelectedAsset}
                placeholder="0"
                maxLength={8}
              />
            </span>
            <span className="amount-gdf text-base font-bold">{selectedAsset?.symbol}</span>
          </div>
          <div className="amount-krw-group">
            <span className="amount-krw text-sm font-normal">{curculateKrw} 원</span>
          </div>
        </div>
        <button type="button" className="amount-refresh-btn" onClick={onClickResetAmountBtn}>
          <img src="./images/refresh-icon.png" alt="잔액 새로고침" className="amount-refresh-icon" />
        </button>
      </div>
    </div>
  );
};

export default SendCheckAmountBox;
